export default "__VITE_ASSET__2JPZezMG__"